@if (transaction?.canUseCard) {
<div class="display-flex justify-content-center">
    <button id="purchase-use-card" class="button button--secondary" [disabled]="loading" (click)="payWithCreditCard()">{{ buttonLabel | translate}}</button>
</div>
}
